var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{
    'success':_vm.isSuccess,
    'error':!_vm.isSuccess,
  }},[_vm._t("default",function(){return [_vm._v("-----")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }